import React from 'react';
import { Flex, Stack, Text, TextInput, Textarea } from '@mantine/core';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import DrawerFlowScreenLayout from 'src/UI/drawer-flow/DrawerFlowScreenLayout';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { TemplateCreationData } from 'src/company/templates/types';

export default function FinalizeTemplateStep(props: StepProps<TemplateCreationData>) {
  const { data, setData } = props;

  const handleTemplateNameChange = (value: string) => {
    setData({
      ...data,
      templateName: value,
    });
  };

  const handleTemplateDescriptionChange = (value: string) => {
    setData({
      ...data,
      templateDescription: value,
    });
  };

  const handleNextPress = async () => {
    const newData = { ...data };
    if (newData.createdTemplate) {
      newData.createdTemplate = {
        ...newData.createdTemplate,
        description: newData.templateDescription,
        displayName: newData.templateName,
      };
    }

    props.nextStep(newData);
  };

  const canGenerate = data.templateName.trim().length > 0;

  return (
    <DrawerFlowScreenLayout
      {...props}
      title="Template details"
      description="Enter a name and description for your template."
      continueText={'Continue'}
      canGoForward={canGenerate && !!data.templateName && !!data.templateDescription}
      hideProgress={true}
      nextStep={handleNextPress}
    >
      <Flex direction="column" gap="md">
        <SettingsList>
          <Flex direction="column" gap="xxxs" mb="sm">
            <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="gray.10">
              Template Configuration
            </Text>
            <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.6">
              Set the name and description for your template
            </Text>
          </Flex>

          <Stack gap="sm">
            <TextInput
              label="Template name"
              placeholder="Enter template name"
              value={data.templateName}
              onChange={event => handleTemplateNameChange(event.currentTarget.value)}
              required
            />

            <Textarea
              label="Description"
              placeholder="Describe what this template is used for and when to use it"
              value={data.templateDescription || ''}
              onChange={event => handleTemplateDescriptionChange(event.currentTarget.value)}
              rows={3}
              required
            />
          </Stack>
        </SettingsList>
      </Flex>
    </DrawerFlowScreenLayout>
  );
}

type SettingsListProps = {
  children: React.ReactNode;
};

function SettingsList({ children }: SettingsListProps) {
  return (
    <Flex direction="column" bg="gray.0" style={{ borderRadius: 12, overflowX: 'hidden' }}>
      <Flex
        direction="column"
        gap="xs"
        p="md"
        bd="1px solid var(--mantine-color-gray-1)"
        style={{ borderRadius: 12, overflowX: 'hidden' }}
        bg="white"
      >
        {children}
      </Flex>
    </Flex>
  );
}
